<template>
  <svg
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.2496 0.0024968L5.69347 0C3.94521 0 2.81541 1.15914 2.81541 2.95322V4.31485H1.25079C1.11559 4.31485 1.0061 4.42446 1.0061 4.55966V6.53251C1.0061 6.66771 1.11571 6.77719 1.25079 6.77719H2.81541V11.7553C2.81541 11.8905 2.92489 12 3.0601 12H5.10148C5.23668 12 5.34617 11.8904 5.34617 11.7553V6.77719H7.17557C7.31078 6.77719 7.42026 6.66771 7.42026 6.53251L7.42101 4.55966C7.42101 4.49474 7.39517 4.43257 7.34935 4.38663C7.30353 4.34069 7.24111 4.31485 7.1762 4.31485H5.34617V3.16058C5.34617 2.60579 5.47837 2.32415 6.20107 2.32415L7.24935 2.32377C7.38443 2.32377 7.49392 2.21416 7.49392 2.07909V0.247183C7.49392 0.112231 7.38456 0.00274648 7.2496 0.0024968Z"
      fill="#040325"
    />
  </svg>
</template>
